import { AWS_CODEBUILD_ARN_ANNOTATION, AWS_CODEBUILD_TAGS_ANNOTATION, AWS_CODEBUILD_ARN_ANNOTATION_LEGACY } from '@aws/aws-codebuild-plugin-for-backstage-common';
import { getOneOfEntityAnnotations } from '@aws/aws-core-plugin-for-backstage-common';
import { createPlugin, createApiFactory, discoveryApiRef, fetchApiRef, createComponentExtension } from '@backstage/core-plugin-api';
import { awsCodeBuildApiRef } from './api/AwsCodeBuildApi.esm.js';
import { AwsCodeBuildApiClient } from './api/AwsCodeBuildApiClient.esm.js';
import { rootRouteRef } from './routes.esm.js';

const isAwsCodeBuildAvailable = (entity) => getOneOfEntityAnnotations(entity, [
  AWS_CODEBUILD_ARN_ANNOTATION,
  AWS_CODEBUILD_TAGS_ANNOTATION,
  AWS_CODEBUILD_ARN_ANNOTATION_LEGACY
]) !== void 0;
const awsCodeBuildPlugin = createPlugin({
  id: "aws-codebuild",
  routes: {
    root: rootRouteRef
  },
  apis: [
    createApiFactory({
      api: awsCodeBuildApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) => new AwsCodeBuildApiClient({ discoveryApi, fetchApi })
    })
  ]
});
const EntityAwsCodeBuildCard = awsCodeBuildPlugin.provide(
  createComponentExtension({
    name: "EntityAwsCodeBuildCard",
    component: {
      lazy: () => import('./components/CodeBuildProjectCard/index.esm.js').then(
        (m) => m.CodeBuildProjectCard
      )
    }
  })
);

export { EntityAwsCodeBuildCard, awsCodeBuildPlugin, isAwsCodeBuildAvailable };
//# sourceMappingURL=plugin.esm.js.map
